import { AxiosResponse } from 'axios';

export function getOrProduce<T>(data: T | (() => T)) {
  if (typeof data === 'function') {
    return (data as () => T)();
  }
  return data;
}

export function createResponse<T>(data?: any) {
  return { data: data as T, status: 200 } as AxiosResponse<T>;
}
